import { Provider } from "./types"

const shouldShowAcceptingPatients = (provider: Provider) : boolean => {
    let showAcceptPatients = true;
    if (provider.isFloatingProvider || provider.isHospitalistProvider || provider.isUrgentCareProvider || provider.isAffiliatedProvider) {
        showAcceptPatients = false;
    }
    if (provider.acceptPatientsOriginal === 'NA' || provider.acceptPatientsOriginal === 'na') {
        showAcceptPatients = false;
    }
    return showAcceptPatients;
}

export default shouldShowAcceptingPatients;